export enum ActivityStatus {
  Loading = 'loading',
  Success = 'success',
  Fail = 'fail',
}
